import React from "react"
import styled from "styled-components"
import tw from "twin.macro"

const CardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 2rem;
`

const FlipCard = styled.div`
  perspective: 1000px;
  ${tw`h-80 lg:h-96`}
  width: 20rem;
  margin: 1rem;

  &:hover .flipper {
    transform: rotateY(180deg);
  }
`

const Flipper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.6s;
  transform-style: preserve-3d;
`

const Front = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  /* background-color: #bbb; */
  color: white;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  h3 {
    margin: 0;
  }
`

const Back = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  /* background-color: #555; */
  color: white;
  transform: rotateY(180deg);
  padding: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  h3 {
    margin: 0;
  }
`

const FlipCards = ({ cards }) => (
  <CardContainer>
    {cards.map(card => (
      <FlipCard key={card.id}>
        <Flipper className="flipper">
          <Front className="bg-gradient-to-r from-gray-900/95 via-gray-700/95 to-gray-900/95 space-y-6 p-6 lg:p-12 shadow-xl">
            <card.graphic className="w-full h-full max-h-36 max-w-36 lg:max-h-36 lg:max-w-12" />
            <h3 className="text-white font-normal text-xl lg:text-2xl">
              {card.title}
            </h3>
            {/* <p>{card.frontContent}</p> */}
          </Front>
          <Back className="bg-gradient-to-r from-gray-900/95 via-gray-700/95 to-gray-900/95 space-y-3 p-3 lg:p-12 shadow-xl">
            <h3 className="text-accent-light font-semibold text-xl lg:text-2xl">
              {card.title}
            </h3>
            <p className="text-sm lg:text-base">{card.backContent}</p>
          </Back>
        </Flipper>
      </FlipCard>
    ))}
  </CardContainer>
)

export default FlipCards
